import { UseQueryOptions } from '@tanstack/react-query';

import { Campaign } from 'domains/campaigns/types';
import useQuery from 'hooks/useQuery';
import { CuredApiPaths, SortDirection } from 'models/enums';

import QueryKeys from './keys';

export type PaginatedArchivedCampaignsResponse = {
    total: number;
    offset: number;
    limit: number;
    data: Campaign[];
};

type UsePaginatedArchivedCampaignsParams = {
    options?: {
        searchTerm?: string;
        limit?: number;
        offset?: number;
        sortColumn?: string;
        sortDirection?: SortDirection;
    };
    reactQueryOptions?: UseQueryOptions<PaginatedArchivedCampaignsResponse, Error>;
};

const usePaginatedArchivedCampaigns = ({
    options = {},
    reactQueryOptions,
}: UsePaginatedArchivedCampaignsParams = {}) => {
    const { searchTerm, limit, offset, sortColumn, sortDirection } = options;

    const queryKey = QueryKeys.ARCHIVED_CAMPAIGNS_PAGINATED(searchTerm, offset, limit, sortColumn, sortDirection);

    const params: Record<string, string | number> = {};
    if (searchTerm?.trim()) {
        params.searchTerm = searchTerm.trim();
    }
    if (limit !== undefined) {
        params.limit = limit;
    }
    if (offset !== undefined) {
        params.offset = offset;
    }
    if (sortColumn && sortDirection) {
        params.sort = `${sortColumn}:${sortDirection}`;
    }

    const axiosOptions = Object.keys(params).length > 0 ? { params } : {};

    return useQuery<PaginatedArchivedCampaignsResponse>(
        queryKey,
        CuredApiPaths.CAMPAIGNS_ARCHIVED_PAGINATED,
        reactQueryOptions,
        axiosOptions
    );
};

export default usePaginatedArchivedCampaigns;
